import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '../../../../helpers'
import { AxiosResponse } from 'axios'
import { Company } from '../../../../models'

export const usePropertyDetails = (id: string) => {
    const { data, isLoading, error } = useQuery<AxiosResponse<Company>, Error>({
        queryKey: ['property', id],
        queryFn: () => axiosInstance.get(`/account-manager/properties/${id}/`),
    })

    return { property: data?.data, isLoading, error }
}
